import React from 'react';
import { Button } from 'antd';
import type { ButtonProps as AntButtonProps } from 'antd';

type ColorT = 'cobalt' | 'white' | 'rxv' | 'rxvWhite';

interface AlumlyButtonProps {
  icon?: React.ReactNode;
  label?: ColorT;
  width?: number;
  loading?: boolean;
  /** HTML button type (MUI-style API kept for compatibility) */
  type?: 'submit' | 'button' | 'reset';
  onClick?: AntButtonProps['onClick'];
  disabled?: boolean;
  component?: React.ElementType;
  children?: React.ReactNode;
  // Legacy MUI props that may still be passed by callers — accepted & ignored
  // so the migration doesn't require touching every call site.
  sx?: any;
  fullWidth?: boolean;
  variant?: string;
  color?: string;
}

// Brand button, now backed by Ant Design. `label` keeps the old colour-variant
// API: rxv/cobalt → primary (light blue), white/rxvWhite → default (white).
const AlumlyButton: React.FC<AlumlyButtonProps> = ({
  icon,
  label = 'rxv',
  width,
  loading = false,
  type,
  onClick,
  disabled,
  fullWidth,
  children,
}) => {
  const antType: AntButtonProps['type'] = label === 'white' || label === 'rxvWhite'
    ? 'default'
    : 'primary';

  return (
    <Button
      type={antType}
      htmlType={type || 'button'}
      icon={icon}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      block={fullWidth}
      style={{
        minWidth: width ? `${width}px` : undefined,
        minHeight: 40,
        fontWeight: 600,
      }}
    >
      {children}
    </Button>
  );
};

export default AlumlyButton;
